<template>
  <div>
    <div class="title-skeleton"></div>
    <div class="skeleton-wrapper">
      <div v-for="index in 6" :key="index" class="card-skeleton-wrapper">
        <div class="card-skeleton">
          <div class="loading-wrapper">
            <div class="container first">
              <div class="bar"></div>
            </div>
            <div class="container second">
              <div class="bar"></div>
            </div>
          </div>
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChoresSkeleton'
}
</script>

<style scoped>
.title-skeleton {
  background-color: #e3e5e8;
  min-height: 33px;
  width: 100%;
  margin-left: 10px;
  margin-bottom: 28px;
  max-width: 267px;
}
.skeleton-wrapper {
  display: flex;
  margin-left: 10px;
  align-items: flex-start;
  flex-direction: column;
  gap: 24px;
}
.circle {
  width: 26px;
  height: 26px;
  background-color: #f5f6f8;
  border-radius: 50%;
}
.card-skeleton {
  background-color: #e3e5e8;
  padding: 18px;
  display: flex;
  align-items: center;
  width: 428px;
  gap: unset;
  justify-content: space-between;
}
.container {
  height: 15px;
  background-color: #f5f6f8;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  border: solid 1px #f5f6f8;
}

.container.first {
  width: 70%;
  margin-bottom: 15px;
}
.container.second {
  width: 90%;
}
.card-skeleton-wrapper {
  width: 100%;
}
.loading-wrapper {
  width: 90%;
}

.bar {
  width: 100%;
  height: 100%;
  background-color: #e3e5e8;
  position: absolute;
  animation: moveBar 2s linear infinite;
  border-radius: 4px;
}

@keyframes moveBar {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
@media screen and (max-width: 767px) {
  .card-skeleton {
    gap: unset;
    justify-content: space-between;
  }
  .card-skeleton {
    width: unset;
  }
  .card-skeleton-wrapper {
    width: 100%;
  }
}
</style>
